module.exports = __webpack_public_path__ + "static/media/arrow-right.1ff6ed33.svg";